
import { useState } from "react";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./administrationManagment.module.css";
import TabBar from "components/tabBar/TabBar";
import { RiUserSettingsLine } from "react-icons/ri";
import FAQManagment from "./FAQManagment";
import EmployManagment from "./employManagment";
import CostManagment from "./costManagment";



export default function AdministrationManagement() {
    const tabs = [
        { id: "mitarbeiter", label: "Mitarbeiter" },
        { id: "faq", label: "FAQ" },
        { id: "cost", label: "Tarife" },
    ];

    const [activeTab, setActiveTab] = useState<string>(tabs[0].id);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    return (
        <div className={styles.container}>
            <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
                <RiUserSettingsLine  className={commonStyles.sectionTitleIcon} />
                <h1>Administration</h1>
            </div>

            <TabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

            <div className={styles.tabContent}>
                {activeTab === "mitarbeiter" && <EmployManagment/>}
                {activeTab === "cost"&& <CostManagment/>}
                {activeTab === "faq"&& <FAQManagment/>}
            </div>
        </div>
    );
}
